



























 import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
 import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
 import { FarmMapFull } from "@/api/analyses/types";
 import Loading from "@/components/loading/Loading.vue";
 import { formattedAreaInHa } from "@/filters/area";
 import AnalysesList from '../analyses-list/AnalysesListController.vue';

 @Component({
   name: 'MapSidebarOverlay',
   components: {
     AgroIcons,
     Loading,
     AnalysesList,
   },
   filters: {
     formattedAreaInHa,
   }
 })

export default class MapSidebarOverlay extends Vue {
  @Prop({ type: Boolean, default: false })
  private isMapSideBarVisible!: boolean;

  @Prop({ type: FarmMapFull })
  private mapFullInfo!: FarmMapFull;

  @Prop({ type: String })
  private uuid!: string;

  @Prop({ type: Boolean, default: false })
  private isLoading!: boolean;


  @Emit("emitCancelAction")
  public cancel() {
  }
}
